"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var CloseIcon_1 = __importDefault(require("./CloseIcon"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return core_1.createStyles({
        collapse: (_a = {
                position: 'absolute',
                left: 0,
                top: 'calc(100% + 10px)',
                zIndex: 1000
            },
            _a[theme.breakpoints.down('sm')] = {
                top: 0,
                height: '100% !important',
                minHeight: '800px !important',
            },
            _a),
        collapseWrapper: (_b = {},
            _b[theme.breakpoints.down('sm')] = {
                height: '100%',
            },
            _b),
        closeIcon: (_c = {
                position: 'absolute',
                top: 0,
                right: 0,
                margin: theme.spacing(1)
            },
            _c[theme.breakpoints.down('sm')] = {
                margin: theme.spacing(3),
            },
            _c),
        root: {
            boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
            border: 'solid 1px #e8e8e8',
            height: '100%',
            overflow: 'hidden',
        },
    });
});
var CollapsingPanel = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Collapse, { in: isOpen, className: className + " " + classes.collapse, classes: { wrapper: classes.collapseWrapper }, timeout: 100 },
        react_1.default.createElement(core_1.Paper, { className: classes.root },
            onClose && (react_1.default.createElement(core_1.IconButton, { className: classes.closeIcon, onClick: onClose },
                react_1.default.createElement(CloseIcon_1.default, { size: 20 }))),
            children)));
};
exports.default = CollapsingPanel;
